export const NOT_EMPLOYED_PROPS = {
  monthlyIncome: {
    type: 'price',
    placeholder: '£0.00',
    icon: 'pound',
    iconVariant: 'dark',
    label: 'Monthly Income After Tax',
    symbol: '',
    name: 'credit.employment_details.retired_details.monthly_income_after_tax',
  },
};

export const MONTHLY_INCOME_VALIDATION = {
  required: { value: true, message: 'Monthly income after tax is required.' },
};
